import { PaginationStateProps } from '../types';
import {
  Client,
  Deposit,
  ExternalBankAccount,
  InternalBankAccount,
  Wallet,
  WalletBalance,
  WalletWithBalance,
  Withdrawal,
  XactAccount,
} from './actions';

// #region InternalBankAccount
export interface InternalBankAccountsState extends PaginationStateProps {
  pending: boolean;
  accounts: InternalBankAccount[] | null;
  error?: string;
}

export const defaultInternalBankAccountsState: InternalBankAccountsState = {
  pending: false,
  accounts: null,
  error: null,
  count: 0,
  next: null,
  previous: null,
};
// #endregion

// #region Wallet
export interface WalletsState extends PaginationStateProps {
  pending: boolean;
  wallets: Wallet[] | null;
  error?: string;
}

export const defaultWalletsState: WalletsState = {
  pending: false,
  wallets: null,
  error: null,
  count: 0,
  next: null,
  previous: null,
};

export interface WalletBalancesState extends PaginationStateProps {
  pending: boolean;
  balances: WalletBalance[] | null;
  error?: string;
}

export const defaultWalletBalancesState: WalletBalancesState = {
  pending: false,
  balances: null,
  error: null,
  count: 0,
  next: null,
  previous: null,
};

export interface WalletsWithBalanceState extends PaginationStateProps {
  pending: boolean;
  wallets: WalletWithBalance[] | null;
  error?: string;
}

export const defaultWalletsWithBalanceState: WalletsWithBalanceState = {
  pending: false,
  wallets: null,
  error: null,
  count: 0,
  next: null,
  previous: null,
};
// #endregion

// #region Client
export interface ClientsState extends PaginationStateProps {
  pending: boolean;
  clients: Client[] | null;
  error?: string;
}

export const defaultClientsState: ClientsState = {
  pending: false,
  clients: null,
  error: null,
  count: 0,
  next: null,
  previous: null,
};
// #endregion

// #region ExternalBankAccount
export interface ExternalBankAccountsState extends PaginationStateProps {
  pending: boolean;
  accounts: ExternalBankAccount[] | null;
  error?: string;
}

export const defaultExternalBankAccountsState: ExternalBankAccountsState = {
  pending: false,
  accounts: null,
  error: null,
  count: 0,
  next: null,
  previous: null,
};
// #endregion

// #region Deposit
export interface DepositState {
  pending: boolean;
  deposit: Deposit | null;
  error?: string;
}

export const defaultDepositState: DepositState = {
  pending: false,
  deposit: null,
  error: null,
};

// #endregion

// #region Withdrawal
export interface WithdrawalState {
  pending: boolean;
  withdrawal: Withdrawal | null;
  error?: string;
}

export const defaultWithdrawalState: WithdrawalState = {
  pending: false,
  withdrawal: null,
  error: null,
};
// #endregion

// #region XactAccount
export interface XactAccountState {
  pending: boolean;
  account: XactAccount | null;
  error?: string;
}

export const defaultXactAccountState: XactAccountState = {
  pending: false,
  account: null,
  error: null,
};

export interface UserXactAccountsState extends PaginationStateProps {
  pending: boolean;
  accounts: XactAccount[] | null;
  error?: string;
}

export const defaultUserXactAccountState: UserXactAccountsState = {
  pending: false,
  accounts: null,
  error: null,
};
// #endregion
